import Vuex from "vuex";
import axios from "axios";
import VueAxios from "vue-axios";
import { ls, lsClear, mdy } from "@/helpers";
import Vue from "vue";
import decode from "jwt-decode";
import printJS from "print-js";

Vue.use(Vuex);

const nonAuthRoutes = ["Signin", "Logout"];

const apiBaseURL = process.env.apiBaseURL;
const isDev = process.env.NODE_ENV !== "production";

Vue.use(VueAxios, axios);

Vue.axios.interceptors.response.use(async function(response) {
  if (response.data && response.data.message == "TOKEN NOT VERIFIED.") {
    lsClear();
    window.location = "/";
  } else return response;
});

Vue.axios.interceptors.request.use(async function(request) {
  var r;
  if (request.url.indexOf(apiBaseURL) != -1) {
    request.headers["App-Client"] = "murimi";
    if (ls("token")) {
      request.headers["Authorization"] = JSON.parse(ls("token"));
      r = request;
    }
  } else {
  }
  return request;
});

function defaultFilters() {
  let tmp = new Date();
  tmp.setDate(tmp.getDate() - 2);

  return {
    fromDate: mdy(tmp),
    toDate: mdy(new Date()),
    page: 1,
    sort: "-createdAt",
    name: "",
    mobile_number: "",
    requestNumber: "",
    deliveryCities: "",
    equipmentTypeId: ""
  };
}

export default new Vuex.Store({
  state: {
    title: "Murimi247 Admin",
    subtitle: "",
    isDev,
    nonAuthRoutes,
    productTypes: [],
    loadingMessage: "",
    loading: false,
    token: ls("token") ? JSON.parse(ls("token")) : "",
    loggedIn: ls("token") ? JSON.parse(ls("token")) != "" : false,
    userAuth: ls("token") ? decode(ls("token")) : null,
    profileLsKey: "user",
    notifications: [],
    selectedBox: {},
    filters: defaultFilters(),
    categories: [],
    retailProductsResponse: {
      meta: {
        total: 0
      },
      products: []
    },
    products: [],
    retailProductsSearchResults: [],
    settings: {
      maxOrdersCutOff: 100,
      orderCreatedSMS: ""
    },
    drivers: [],
    users: []
  },
  mutations: {
    loadingMessage(state, message) {
      state.loadingMessage = message;
    },
    subtitle(state, subtitle) {
      state.subtitle = subtitle;
    },
    title(state, sutitle) {
      state.title = title;
    },
    loading(state, loading) {
      state.loading = loading;
    },
    loggedIn(state, loggedIn) {
      state.loggedIn = loggedIn;
    },
    notifications(state, notifications) {
      state.notifications = notifications;
    },
    productTypes(state, productTypes) {
      state.productTypes = productTypes;
    },
    selectedBox(state, selectedBox) {
      state.selectedBox = selectedBox;
    },
    setFilters(state, newFilters) {
      state.filters = { ...state.filters, ...newFilters };
      console.log(newFilters, state.filters);
    },
    setCategories(state, categories) {
      state.categories = categories;
    },
    setRetailProducts(
      state,
      retailProductsResponse = { meta: {}, products: {} }
    ) {
      state.retailProductsResponse = retailProductsResponse;
    },
    setRetailProductsSearchResults(state, retailProductsSearchResults) {
      state.retailProductsSearchResults = retailProductsSearchResults;
    },
    setProducts(state, products) {
      state.products = products;
    },
    setSettings(state, settings) {
      state.settings = settings;
    },
    setDrivers(state, drivers) {
      state.drivers = drivers;
    },
    setUsers(state, users) {
      state.users = users;
    }
  },
  actions: {
    getStats({ commit }) {
      return new Promise((resolve, reject) => {
        axios
          .get(`${apiBaseURL}/admin/stats`)
          .then(res => {
            res = res.data;
            if (res.message == "STATS FOUND.") resolve(res.data);
            else reject();
          })
          .catch(e => {
            reject(e);
          });
      });
    },
    sendSMS({ commit }, data) {
      return new Promise((resolve, reject) => {
        axios
          .post(`${apiBaseURL}/sms`, data)
          .then(res => {
            res = res.data;
            if (res.message == "SMS SENT.") resolve();
            else reject();
          })
          .catch(e => {
            reject(e);
          });
      });
    },
    login({ commit }, creds) {
      return new Promise((resolve, reject) => {
        axios
          .post(`${apiBaseURL}/auth/login`, creds)
          .then(res => {
            res = res.data;
            if (res.message == "LOGIN SUCCESSFUL." && res.data.token)
              resolve(res.data.token);
            else reject();
          })
          .catch(e => {
            reject(e);
          });
      });
    },
    resetPassword({ commit }, email) {
      return new Promise(async (resolve, reject) => {
        // reset password
        const url = `${apiBaseURL}/auth/reset-password`;
        try {
          const res = (await axios.post(url, { email })).data;

          if (res.message === "PASSWORD RESET.") {
            resolve();
          } else {
            reject(new Error(res.message));
          }
        } catch (e) {
          reject(e);
        }
      });
    },
    changePassword({ commit }, data) {
      return new Promise(async (resolve, reject) => {
        // reset password
        const url = `${apiBaseURL}/auth/change-password`;
        try {
          const res = (await axios.post(url, data)).data;

          if (res.message === "PASSWORD CHANGED.") {
            resolve();
          } else {
            reject(new Error(res.message));
          }
        } catch (e) {
          reject(e);
        }
      });
    },
    getFarms({ commit }) {
      return new Promise((resolve, reject) => {
        axios
          .get(`${apiBaseURL}/farms/`)
          .then(res => {
            res = res.data;
            if (res.message == "FARMS FOUND." && res.data) {
              resolve(res.data);
            } else {
              resolve(null);
            }
          })
          .catch(e => {
            reject(e);
          });
      });
    },
    getEquipmentTypes({ commit }) {
      return new Promise((resolve, reject) => {
        axios
          .get(`${apiBaseURL}/equipment/types`)
          .then(res => {
            res = res.data;
            if (res.message == "EQUIPMENT TYPES FOUND." && res.data) {
              resolve(res.data);
            } else {
              resolve(null);
            }
          })
          .catch(e => {
            reject(e);
          });
      });
    },

    getUsersByType({ commit }, type) {
      return new Promise((resolve, reject) => {
        axios
          .get(`${apiBaseURL}/admin/users?type=${type}`)
          .then(res => {
            res = res.data;
            if (res.message == "ALL USERS FOUND." && res.data) {
              resolve(res.data);
            } else {
              resolve(null);
            }
          })
          .catch(e => {
            reject(e);
          });
      });
    },
    getTypeEquipment({ commit }, equipmentTypeId) {
      return new Promise((resolve, reject) => {
        axios
          .get(`${apiBaseURL}/equipment?equipmentTypeId=${equipmentTypeId}`)
          .then(res => {
            res = res.data;
            if (res.message == "EQUIPMENT FOUND." && res.data) {
              console.log(res.data.equipment);
              resolve(res.data.equipment);
            } else {
              resolve(null);
            }
          })
          .catch(e => {
            reject(e);
          });
      });
    },

    
    getUsers({ commit }, query = null) {
      return new Promise((resolve, reject) => {
        const queryString = query
          ? `?${Object.keys(query)
              .map(key => `${key}=${query[key]}`)
              .join("&")}`
          : "?limit=10000";
        axios
          .get(`${apiBaseURL}/admin/users${queryString}`)
          .then(res => {
            res = res.data;
            if (res.message == "ALL USERS FOUND." && res.data) {
              commit("setUsers", res.data);
              resolve(res.data);
            } else resolve(null);
          })
          .catch(e => {
            reject(e);
          });
      });
    },
    deleteUser({ commit }, userId) {
      return new Promise((resolve, reject) => {
        axios
          .delete(`${apiBaseURL}/admin/users/${userId}`)
          .then(res => {
            res = res.data;
            return res.message == "USER DELETED." ? resolve() : reject(res);
          })
          .catch(e => {
            reject(e);
          });
      });
    },
    editUser({ commit }, user) {
      return new Promise((resolve, reject) => {
        axios
          .put(`${apiBaseURL}/admin/users/${user.id}`, user)
          .then(res => {
            res = res.data;
            return res.message == "CHANGES SAVED." ? resolve() : reject(res);
          })
          .catch(e => {
            reject(e);
          });
      });
    },
    createUser({ commit }, user) {
      console.log(user);
      return new Promise((resolve, reject) => {
        axios
          .post(`${apiBaseURL}/auth/signup`, user)
          .then(res => {
            res = res.data;
            return res.message == "REGISTRATION SUCCESSFUL."
              ? resolve()
              : reject(res);
          })
          .catch(e => {
            reject(e);
          });
      });
    },
    editEquipment({ commit }, equipment) {
      return new Promise((resolve, reject) => {
        axios
          .put(`${apiBaseURL}/equipment/${equipment._id}`, equipment)
          .then(res => {
            res = res.data;
            return res.message == "CHANGES SAVED." ? resolve() : reject(res);
          })
          .catch(e => {
            reject(e);
          });
      });
    },
    deleteEquipment({ commit }, equipmentId) {
      return new Promise((resolve, reject) => {
        axios
          .delete(`${apiBaseURL}/equipment/${equipmentId}`)
          .then(res => {
            res = res.data;
            return res.message == "EQUIPMENT DELETED."
              ? resolve()
              : reject(res);
          })
          .catch(e => {
            reject(e);
          });
      });
    },
    createEquipmentType({ commit }, equipmentType) {
      return new Promise((resolve, reject) => {
        axios
          .post(`${apiBaseURL}/equipment/types`, equipmentType)
          .then(res => {
            res = res.data;
            if (res.message == "EQUIPMENT TYPE SAVED.") {
              resolve(res.data); //
            } else {
              reject(res);
            }
          })
          .catch(e => {
            reject(e);
          });
      });
    },
    editEquipmentType({ commit }, equipmentType) {
      return new Promise((resolve, reject) => {
        axios
          .put(
            `${apiBaseURL}/equipment/types/${equipmentType.id}`,
            equipmentType
          )
          .then(res => {
            res = res.data;
            return res.message == "CHANGES SAVED." ? resolve() : reject(res);
          })
          .catch(e => {
            reject(e);
          });
      });
    },
    deleteEquipmentType({ commit }, equipmentTypeId) {
      return new Promise((resolve, reject) => {
        axios
          .delete(`${apiBaseURL}/equipment/types/${equipmentTypeId}`)
          .then(res => {
            res = res.data;
            return res.message == "EQUIPMENT TYPE DELETED."
              ? resolve()
              : reject(res);
          })
          .catch(e => {
            reject(e);
          });
      });
    },
    createEquipment({ commit }, equipment) {
      return new Promise((resolve, reject) => {
        axios
          .post(`${apiBaseURL}/equipment`, equipment)
          .then(res => {
            res = res.data;
            if (res.message == "EQUIPMENT SAVED.") {
              resolve(res.data);
            } else {
              reject(res);
            }
          })
          .catch(e => {
            reject(e);
          });
      });
    },

    // CROP MANAGER
    getCrops({ commit }) {
      return new Promise((resolve, reject) => {
        axios
          .get(`${apiBaseURL}/crop-manager`)
          .then(res => {
            res = res.data;
            if (res.message == "CROP LIST FOUND." && res.data) {
              resolve(res.data.crops);
            } else {
              resolve(null);
            }
          })
          .catch(e => {
            reject(e);
          });
      });
    },
    getCropTradeNames({ commit }) {
      return new Promise((resolve, reject) => {
        axios
          .get(`${apiBaseURL}/crop-trade-names`)
          .then(res => {
            res = res.data;
            if (res.message == "CROP  TRADE NAME  LIST FOUND." && res.data) {
              resolve(res.data.tradeNames);
            } else {
              resolve(null);
            }
          })
          .catch(e => {
            reject(e);
          });
      });
    },
    getCropTypes({ commit }) {
      return new Promise((resolve, reject) => {
        axios
          .get(`${apiBaseURL}/crop-types`)
          .then(res => {
            res = res.data;
            if (res.message == "CROP TYPE NAMES  LIST FOUND." && res.data) {
              resolve(res.data.tradeNames);
            } else {
              resolve(null);
            }
          })
          .catch(e => {
            reject(e);
          });
      });
    },

    getTips({ commit }) {
      return new Promise((resolve, reject) => {
        axios
          .get(`${apiBaseURL}/crop-manager/crop-tip/all`)
          .then(res => {
            res = res.data;
            let tips = res.data;

            let cleanTips = tips.map(tip => {
              return {
                _id: tip._id,
                tip: tip.tip,
                days: tip.days,
                cropId: tip.cropId === null ? null : tip.cropId._id,
                cropName: tip.cropId == null ? null : tip.cropId.cropName,
                cropTradeName:
                  tip.cropId == null ? null : tip.cropId.cropTradeName
              };
            });

            if (res.message == "Crop Tip options Requested." && cleanTips) {
              resolve(cleanTips);
            } else {
              resolve(null);
            }
          })
          .catch(e => {
            reject(e);
          });
      });
    },
    createCrop({ commit }, newCrop) {
      return new Promise((resolve, reject) => {
        axios
          .post(`${apiBaseURL}/crop-manager`, newCrop)
          .then(res => {
            res = res.data;
            if (res.message == "Crop SAVED.") {
              resolve(res.data); //
            } else {
              reject(res);
            }
          })
          .catch(e => {
            reject(e);
          });
      });
    },
    createCropType({ commit }, newCropType) {
      return new Promise((resolve, reject) => {
        axios
          .post(`${apiBaseURL}/crop-types`, newCropType)
          .then(res => {
            res = res.data;
            if (res.message == "Crop Type Name Saved Successfully.") {
              resolve(res.data.savedCropTypeName); //
            } else {
              reject(res);
            }
          })
          .catch(e => {
            reject(e);
          });
      });
    },
    createCropTradeName({ commit }, newCropTradeName) {
      return new Promise((resolve, reject) => {
        axios
          .post(`${apiBaseURL}/crop-trade-names`, newCropTradeName)
          .then(res => {
            res = res.data;
            if (res.message == "Crop Trade Name Saved Successfully.") {
              resolve(res.data.savedCropTradeName); //
            } else {
              reject(res);
            }
          })
          .catch(e => {
            reject(e);
          });
      });
    },
    addNewCropTip({ commit }, crop) {
      return new Promise((resolve, reject) => {
        axios
          .post(`${apiBaseURL}/crop-manager/crop-tip`, {
            cropId: crop._id,
            ...crop
          })
          .then(res => {
            res = res.data;
            if (res.message == "Crop Tip SAVED.") {
              resolve(res.data); //
            } else {
              reject(res);
            }
          })
          .catch(e => {
            reject(e);
          });
      });
    },
    editCropTip({ commit }, cropTip) {
      return new Promise((resolve, reject) => {
        axios
          .put(`${apiBaseURL}/crop-manager/crop-tip/${cropTip._id}`, cropTip)
          .then(res => {
            res = res.data;
            return res.message == "CHANGES SAVED." ? resolve() : reject(res);
          })
          .catch(e => {
            reject(e);
          });
      });
    },
    // Shop: Ginimbi
    getShopProducts({ commit }) {
      return new Promise((resolve, reject) => {
        axios
          .get("https://murimi-ecomerce.herokuapp.com/api/products")
          .then(res => {
            res = res.data;
            if (
              res.message == "successfully fetched the products" &&
              res.data
            ) {
              resolve(res.data.products);
            } else {
              resolve(null);
            }
          })
          .catch(e => {
            reject(e);
          });
      });
    },
    getShopOrders({ commit }) {
      return new Promise((resolve, reject) => {
        axios
          .get("https://murimi-ecomerce.herokuapp.com/api/orders")
          .then(res => {
            res = res.data;
            console.log(res);
            if (res) {
              resolve(res);
            } else {
              resolve(null);
            }
          })
          .catch(e => {
            reject(e);
          });
      });
    },
    createProduct({ commit }, newProduct) {
      return new Promise((resolve, reject) => {
        axios
          .post(
            "https://murimi-ecomerce.herokuapp.com/api/products",
            newProduct
          )
          .then(res => {
            res = res.data;
            if (res) {
              resolve(res.data); //
            } else {
              reject(res);
            }
          })
          .catch(e => {
            reject(e);
          });
      });
    },

    getEquipmentRequests({ commit }, filters) {
      const queryString = filters
        ? `?${Object.keys(filters)
            .map(key => `${key}=${filters[key]}`)
            .join("&")}`
        : "";
      return new Promise((resolve, reject) => {
        axios
          .get(`${apiBaseURL}/equipment-requests/${queryString}`)
          .then(res => {
            res = res.data;
            if (res.message == "EQUIPMENT REQUESTS FOUND.") {
              console.log(res.data.equipmentRequests);
              console.log("here equip");
              resolve(res.data.equipmentRequests);
            } else {
              reject(res);
            }
          })
          .catch(e => {
            reject(e);
          });
      });
    },
    setEquipmentRequestStatus({ commit }, data) {
      const { equipmentRequestId, changes } = data;
      delete data.equipmentRequestId;
      return new Promise((resolve, reject) => {
        axios
          .put(
            `${apiBaseURL}/equipment-requests/${equipmentRequestId}`,
            changes
          )
          .then(res => {
            res = res.data;
            if (res && res.message == "CHANGES SAVED.") {
              resolve();
            } else {
              reject(res);
            }
          })
          .catch(e => {
            reject(e);
          });
      });
    },
    getEquipmentRequestsStats({ commit }, data) {
      return new Promise((resolve, reject) => {
        axios
          .get(`${apiBaseURL}/equipment-requests/stats?limit=100`)
          .then(res => {
            res = res.data;
            if (res && res.message == "STATS FOUND.") {
              resolve(res.data);
            } else {
              reject(res);
            }
          })
          .catch(e => {
            reject(e);
          });
      });
    },
    // Soil Tests Requests
    getSoilTestRequests({ commit }) {
      return new Promise((resolve, reject) => {
        axios
          .get(`${apiBaseURL}/soil-test`)
          .then(res => {
            res = res.data;
            if (
              res.message == "SoilTestRequest Tip options Requested." &&
              res.data
            ) {
              resolve(res.data);
            } else {
              resolve(null);
            }
          })
          .catch(e => {
            reject(e);
          });
      });
    },
    addSoilTestsResults({ commit }, result) {
      return new Promise((resolve, reject) => {
        axios
          .post(`${apiBaseURL}/soil-test-result`, {
            soilTest: result._id,
            nitrogen: result.nitrogen,
            potassium: result.potassium,
            phOnly: result.phOnly,
            magnesium: result.magnesium,
            OrganicMatter: result.OrganicMatter,
            salinity: result.salinity
          })

          .then(res => {
            res = res.data;
            // console.log(res.data)
            if (res.message == "SoilTestResult  SAVED.") {
              resolve(res.data);
            } else {
              reject(res);
            }
          })
          .catch(e => {
            reject(e);
          });
      });
    },
    getSoilTestResults({ commit }) {
      return new Promise((resolve, reject) => {
        axios
          .get(`${apiBaseURL}/soil-test-result`)
          .then(res => {
            res = res.data;
            if (
              res.message == "SoilTestResult Tip options Resulted." &&
              res.data
            ) {
              resolve(res.data.docs);
              console.log(res.data.docs);
            } else {
              resolve(null);
            }
          })
          .catch(e => {
            reject(e);
          });
      });
    },
    getProvinces({ commit }) {
      return new Promise((resolve, reject) => {
        axios
          .get(`${apiBaseURL}/province`)
          .then(res => {
            res = res.data;
            if (res.message == "found provinces." && res.data) {
              console.log(res.data);
              resolve(res.data);
            } else {
              resolve(null);
            }
          })
          .catch(e => {
            reject(e);
          });
      });
    },

    
    /*
Array(6) [
  { _id: '64214bbf5934ae387b67d7c4', districtName: 'Buhera', provinceId: '6411821830944cfe48258c5c', __v: 0 }, { _id: '64214bc85934ae5a8767d7c6', districtName: 'Chimanimani', provinceId: '6411821830944cfe48258c5c', __v: 0 },
  { _id: '64214bd05934aef60667d7c8', districtName: 'Chipinge', provinceId: '6411821830944cfe48258c5c', __v: 0 }, { _id: '64214bd75934ae7f6867d7ca', districtName: 'Makoni', provinceId: '6411821830944cfe48258c5c', __v: 0 },
  { _id: '64214bdf5934ae53b567d7cc', districtName: 'Mutare', provinceId: '6411821830944cfe48258c5c', __v: 0 }, { _id: '64214bf05934ae7b2867d7d0', districtName: 'Nyanga', provinceId: '6411821830944cfe48258c5c', __v: 0 },
  
]
*/





    getDistricts({ commit }, provinceId) {
      return new Promise((resolve, reject) => {
        axios
          .get(`${apiBaseURL}/district`)
          .then(res => {
            res = res.data;
            if (res.message == "found districts." && res.data) {
              // console.log(res.data)
              const districts = res.data.districts.filter(
                district => district.provinceId === provinceId
              );
              // console.log(districts)
              resolve({ districts });
              // resolve({"districts": districts});
            } else {
              resolve(null);
            }
          })
          .catch(e => {
            reject(e);
          });
      });
    },
    /**
 * 
 working on farm Assesments
 */
 getFarmAssessments({ commit }, query = null) {
  return new Promise((resolve, reject) => {
    const queryString = query
      ? `?${Object.keys(query)
          .map(key => `${key}=${query[key]}`)
          .join("&")}`
      : "?limit=10000";
    axios
      .get(`${apiBaseURL}/farmAssessment${queryString}`)
      .then(res => {
        res = res.data;
        if (res.message == "FARM  ASSESSMENT FOUND." && res.data) {
          commit("setFarmAssessments", res.data);
          resolve(res.data);
        } else resolve(null);
      })
      .catch(e => {
        reject(e);
      });
  });
},




  },
  getters: {
    loadingMessage(state) {
      return state.loadingMessage;
    },
    loading(state) {
      return state.loading;
    },
    title(state) {
      return state.title;
    },
    subtitle(state) {
      return state.subtitle;
    },
    user(state) {
      return state.user;
    },
    userAuth(state) {
      return state.userAuth;
    },
    loggedIn(state) {
      return state.loggedIn;
    },
    notifications(state) {
      return state.notifications;
    },
    user(state) {
      return state.user;
    },
    cycles(state) {
      return state.cycles;
    },
    filters(state) {
      return state.filters;
    },
    users: state => state.users
  }
});



// WEBPACK FOOTER //
// ./src/store/index.js